<template>
  <v-btn icon @click="toggleFavorite">
    <v-icon v-if="isAddToFavourite">mdi-star</v-icon>
    <v-icon v-else>mdi-star-outline</v-icon>
  </v-btn>
</template>

<script>
import { useMutation } from '@vue/apollo-composable';
import objectGql from '@/api/objects/item.graphql';

export default {
  props: {
    id: { type: String, required: true },
    isAddToFavourite: { type: Boolean, default: false }
  },
  name: 'ToggleFavorite',
  setup(props) {
    const { mutate: addToFavorite } = useMutation(objectGql.addToFavorite);

    const toggleFavorite = () => {
      addToFavorite({
        input: {
          favourite: !props.isAddToFavourite,
          objectsId: [props.id]
        }
      });
    };

    return {
      toggleFavorite
    };
  }
};
</script>
